import React from 'react';
import { DashboardWidget } from '../../types/Dashboard';
import MetricCardWidget from './widgets/MetricCardWidget';
import LineChartWidget from './widgets/LineChartWidget';
import BarChartWidget from './widgets/BarChartWidget';
import PieChartWidget from './widgets/PieChartWidget';
import AreaChartWidget from './widgets/AreaChartWidget';
import ListWidget from './widgets/ListWidget';
import TableWidget from './widgets/TableWidget';
import StatCardWidget from './widgets/StatCardWidget';
import AlertListWidget from './widgets/AlertListWidget';
import ComparisonWidget from './widgets/ComparisonWidget';
import EvaluationReportWidget from './widgets/EvaluationReportWidget';

interface WidgetContainerProps {
  widget: DashboardWidget;
  onRemove: (widgetId: string) => void;
  onConfigChange: (widgetId: string, config: Record<string, any>) => void;
  isEditing: boolean;
}

const WidgetContainer: React.FC<WidgetContainerProps> = ({
  widget,
  onRemove,
  onConfigChange,
  isEditing
}) => {
  const renderWidget = () => {
    switch (widget.type) {
      case 'metric-card':
        return <MetricCardWidget config={widget.config || {}} size={widget.size} />;
      case 'line-chart':
        return <LineChartWidget config={widget.config || {}} size={widget.size} />;
      case 'bar-chart':
        return <BarChartWidget config={widget.config || {}} size={widget.size} />;
      case 'pie-chart':
        return <PieChartWidget config={widget.config || {}} size={widget.size} />;
      case 'area-chart':
        return <AreaChartWidget config={widget.config || {}} size={widget.size} />;
      case 'list':
        return <ListWidget config={widget.config || {}} size={widget.size} />;
      case 'table':
        return <TableWidget config={widget.config || {}} size={widget.size} />;
      case 'stat-card':
        return <StatCardWidget config={widget.config || {}} size={widget.size} />;
      case 'alert-list':
        return <AlertListWidget config={widget.config || {}} size={widget.size} />;
      case 'comparison':
        return <ComparisonWidget config={widget.config || {}} size={widget.size} />;
      case 'evaluation-report':
        return <EvaluationReportWidget config={widget.config || {}} size={widget.size} />;
      default:
        return <div className="p-4 text-gray-500">Widget não encontrado</div>;
    }
  };

  return (
    <div className="relative h-full w-full bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-100 dark:border-gray-700 hover:shadow-md transition-shadow overflow-hidden flex flex-col">
      {/* Título do Widget */}
      <div className="px-4 pt-4 pb-3 border-b border-gray-100 flex items-center justify-between flex-shrink-0 widget-header">
        <h3 className="text-base font-semibold text-gray-900">{widget.title || 'Widget'}</h3>
        {isEditing && (
          <div className="flex gap-2 widget-controls" onClick={(e) => e.stopPropagation()}>
            <button
              type="button"
              className="widget-button px-2 py-1 text-xs font-medium text-gray-600 hover:text-gray-900 hover:bg-gray-50 rounded transition-colors"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onConfigChange(widget.id, { openSettings: true });
              }}
            >
              Configurar
            </button>
            <button
              type="button"
              className="widget-button px-2 py-1 text-xs font-medium text-red-600 hover:text-red-700 hover:bg-red-50 rounded transition-colors"
              onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();
                if (window.confirm('Tem certeza que deseja remover este widget?')) {
                  onRemove(widget.id);
                }
              }}
            >
              Remover
            </button>
          </div>
        )}
      </div>
      {/* Conteúdo do Widget */}
      <div className="flex-1 overflow-hidden p-4 min-h-0">
        {renderWidget()}
      </div>
    </div>
  );
};

export default WidgetContainer;

